require('../table/gh_table.js')
require('../filter_advanced/filter_advanced.directive.js')
require('./recycle_bin.scss')
angular.module('ghRecycleBinModule', [])
.directive('ghRecycleBin', [
  function() {
  return {
    scope: {
      fieldModel: '='
    },
    controller: ['$scope', '$element', '$timeout', 'GhDialog', 'ghToastService', async function($scope, $element, $timeout, GhDialog, ghToastService){
      $scope.isShowLoader = false;

      const trashItems = await gudhub.getItems($scope.fieldModel.data_model.app_id, true);

      $scope.openDialog = async () => {
        if($scope.fieldModel.data_model.mode === 'app' && $scope.fieldModel.data_model.app_id) {
          $scope.isShowLoader = true;
          $scope.app = await gudhub.getApp($scope.fieldModel.data_model.app_id);
          $scope.fields = []

          for(field of $scope.app.field_list) {
            const instance = await gudhub.ghconstructor.getInstance(field.data_type);
			      if(instance.getTemplate().constructor === 'field' || instance.getTemplate().constructor === 'file') {
              $scope.fields.push({
                field_id: field.field_id,
                show: 1,
                width: '150px'
              })
            }
          }
          
          $scope.fieldModel.data_model.fields = $scope.fields;
          $scope.isShowLoader = false;
        }

        GhDialog.show({
          class: 'gh-recycle-bin-dialog',
          position: 'full',
          template: {
            toolbar: '<div class="gh-recycle-bin-dialog-toolbar"><span gh-icon="recycle_bin 0D99FF 40px"></span><p>Recycle Bin</p></div>',
            content: /*html*/`
              <div class="recycle-wrapper">
                  <gh-filter-advanced field-model="filterModel"></gh-filter-advanced>
                  <div class="gh-table-wrap"><gh-table class="gh-table" gh-field-data="tableModel" gh-app-id="{{appId}}"></gh-table></div>
              </div>
              <div class="gh-btn btn-blue restore-recycle-bin-btn" ng-click="restore()">Restore</div>
            `
          },
          locals: {
            fieldModel: $scope.fieldModel,
            trashItems
          },
          controller: ['$scope', 'fieldModel', 'trashItems', async function ($scope, fieldModel, trashItems) {
            $scope.appId = fieldModel.data_model.app_id;
            $scope.selectedItems = [];

            const fieldIdForFilter = `recycle_bin_field_id_${fieldModel.data_model.app_id}`;
            $scope.filterModel = {
              data_model: {
                app_id: $scope.appId,
                field_id: fieldIdForFilter,
                disable_filter_auto_save: 0
              },
              field_id: fieldIdForFilter,
            }

            $scope.tableModel = {
              field_id: fieldIdForFilter,
              data_model: {
                app_id: fieldModel.data_model.app_id,
                filters_list: [],
                replace_items: trashItems,
                table_settings: {
                    columns_to_view: fieldModel.data_model.fields, /* Array of column settings, wich view in table.*/
                    /* Height of table (Row items count)*/
                    action: '',
                    /* Action on click on item*/
                    selected_item: 1, /* Can be item will be selected. '0' - Not selected, '1' - selected*/
                    items_order: 'increase'
                },
              }
            }

            $scope.$on('select-table-item', (event, data) => {
              $scope.selectedItems = data;
            });

            $scope.restore = async () => {
              if($scope.selectedItems.length) {
                try {
                  await gudhub.restoreItems($scope.appId, $scope.selectedItems);
                  ghToastService.simple('Item(s) was successfully restored!', 'bottom right');
                }
                catch(e) {
                  ghToastService.simple('Error when try to restore items. Please, try again!', 'bottom right');
                  console.error(e)
                }
                finally {
                  $scope.hide();
                }
              }
            }
          }]
        })
      }
    }],
    template: /*html*/`
    <div ng-if="fieldModel.data_model.mode === 'app'" ng-click="openDialog()" class="wrapper-recycle-bin-icon" ng-class="{'disabled': isShowLoader}">
      <gh-loader color="blue" ng-if="isShowLoader"></gh-loader>
      <div class="apps-list-icon" ng-if="!isShowLoader" gh-icon="{{fieldModel.data_model.icon.icon_id}} {{fieldModel.data_model.icon.icon_color}} 110px app {{fieldModel.data_model.icon.gradient_up}} {{fieldModel.data_model.icon.gradient_down}}"></div>
      <div class="name">{{fieldModel.data_model.name}}</div>
    </div>
    <div ng-if="!fieldModel.data_model.mode" gh-icon="recycle_bin 0D99FF 40px" ng-click="openDialog()" class="gh-recycle-bin"></div>
      `
  }
}])